export const homeObjOne = {
  headline: "ژانر داستانی",
  description:
    "ادبیات داستانی شکلی از روایت است که در همه یا بخشی از آن به رویدادهایی اشاره می‌شود که واقعی نیستند، یعنی خیالی هستند و ساختهٔ ذهن نویسندهٔ اثرند. در مقابل آن ادبیات غیر داستانی قرار دارد که عمدتاً به رویدادهای واقعی می‌پردازد (نظیر تاریخ‌نگاری، زندگینامه‌نویسی و…).ادبیات داستانی یا داستان تخیلی سبکی است در ادبیات و به داستان‌هایی اطلاق می‌شود که بخشی از آن یا همه آن به صورت حکایتی یا نقلی و به شیوه خیالی و تصوری نوشته می‌شود. اگر چه سبک تخیلی توصیف یک اثر ادبی است اما این اصلاح و سبک برای آثار موسیقی، فیلم، مستند و تئاتر نیز استفاده می‌شود",
  imgStart: "",
  img: require("./images/hero.png").default,
  alt: "کتاب های داستانی",
  start: "",
};
